import React from "react";
import { FaLaptopCode, FaTerminal, FaGitAlt } from "react-icons/fa";
import { SiVisualstudiocode } from "react-icons/si";

export const Tools = () => {
  return (
    <div
      id="tools"
      className="w-full bg-cyber-black text-gray-300 py-12 px-6 flex items-center justify-center border-t border-cyber-green/5"
    >
      <div className="max-w-5xl w-full">
        <div className="border border-cyber-blue/20 bg-cyber-darker/35 p-6 rounded-2xl flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center space-x-4">
            <div className="p-3 bg-cyber-blue/10 border border-cyber-blue/30 text-cyber-blue rounded-xl">
              <FaLaptopCode size={28} />
            </div>
            <div>
              <h3 className="font-mono text-sm font-bold text-white uppercase tracking-wider">
                DEV_ENVIRONMENT // ACTIVE
              </h3>
              <p className="text-xs text-cyber-gray-400 font-mono mt-1">
                Optimized workspace configurations for daily productivity.
              </p>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-xs font-mono">
            <div className="flex items-center space-x-2 px-3 py-2 bg-cyber-black border border-cyber-gray-800 rounded-lg">
              <SiVisualstudiocode className="text-blue-400" />
              <span>VS Code Editor</span>
            </div>
            <div className="flex items-center space-x-2 px-3 py-2 bg-cyber-black border border-cyber-gray-800 rounded-lg">
              <FaGitAlt className="text-orange-500" />
              <span>Git Version Control</span>
            </div>
            <div className="flex items-center space-x-2 px-3 py-2 bg-cyber-black border border-cyber-gray-800 rounded-lg">
              <FaTerminal className="text-cyber-green" />
              <span>Windows PowerShell / Terminus</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tools;
